import {
  forwardRef,
  useState,
  useEffect,
  useImperativeHandle,
  useRef,
  RefObject,
} from "react";
import {
  FaCaretDown,
  FaPlay,
  FaPause,
  FaSlash,
  FaEye,
  FaFastForward,
  FaFastBackward,
} from "react-icons/fa";

import SwitchPopup from "../SwitchPopup/SwitchPopup";
import { ImVolumeHigh, ImVolumeMedium, ImVolumeLow } from "react-icons/im";
// import { BsPip } from "react-icons/bs";
import { MdFullscreen, MdFullscreenExit } from "react-icons/md";
// import ReactHlsPlayer from "react-hls-player";
import { isEmpty } from "lodash";
import { OverlayTrigger, Popover, Button, Modal, Tooltip } from "react-bootstrap";
import VideoTag from "../VideoTag/VideoTag";
import VideoBookmark from "../VideoBookmark/VideoBookmark";
import classes from "./VideoPlayer.module.css";
import { useContext } from "react";
import VideoDescription from "./VideoDescription";
import SecondaryAdBannerFullscreen from "../SecondaryAdBanner/SecondaryAdBannerFullscreen";
import VideoHighlighter from "./VideoHighlighter";
import VideoContext from "../../store/video-context";
import { toast } from "react-toastify";
import YouTube from "react-youtube";
import ifvisible from "ifvisible";
import { useLocation } from "react-router-dom";
import OutsideClickHandler from "react-outside-click-handler";
import { get,set } from "js-cookie";
// @ts-ignore
import Hls from "hls.js";
import { Link } from "react-router-dom";
import ReactGA from 'react-ga';
import $ from 'jquery';
import AdPopup from "../AdPopup/AdPopup";

var timeCounter = 0;
var startCounter = false;
var setVideoPlayed = false;
var isYTSeek = false;

const VideoPlayer = forwardRef((props: any, ref: any) => {
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const vContext = useContext(VideoContext);
  const playerRef = useRef() as RefObject<HTMLVideoElement>; //createRef<HTMLVideoElement>();
  const [hls, setHls] = useState(new Hls());
  const volumeRef = useRef() as RefObject<HTMLInputElement>;
  // const overlayRef = useRef();
  const seekTooltipRef = useRef() as RefObject<HTMLDivElement>;
  const videoContainerRef = useRef() as RefObject<HTMLDivElement>;
  const vContainerRef = useRef() as RefObject<HTMLDivElement>;
  const playbackAnimationRef = useRef() as RefObject<HTMLDivElement>;
  const videoControlsRef = useRef() as RefObject<HTMLDivElement>;
  const positionRef = useRef() as RefObject<HTMLDivElement>;
  const seekRef = useRef() as RefObject<HTMLInputElement>;
  const progressBarRef = useRef() as RefObject<HTMLProgressElement>;
  const [videoData, setVideoData] = useState(props.videoData);
  const [duration, setDuration] = useState("00:00");
  const [timeElapsed, setTimeElapsed] = useState("00:00");
  const [max, setMax] = useState(0);
  const [player, setPlayer] = useState<any>();

  const [YT_time, setYT_time] = useState("00:00:00");
  const [isYTPlaying, setIsYTPlaying] = useState(false);
  const [isYTNotStarted, setIsYTNotStarted] = useState(true);
  const [isYTMaxTime, setIsYTMaxTime] = useState(0);
  const [liveIconColor, setLiveIconColor] = useState("#FD6632");

  // Flag Declaration Starts
  const [isPlaying, setIsPlaying] = useState(false);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [controlsVisible, setControlsVisible] = useState(true);
  const [isMute, setIsMute] = useState(true);
  const [isLow, setIsLow] = useState(false);
  const [isMedium, setIsMedium] = useState(false);
  const [isHigh, setIsHigh] = useState(true);
  const [saveOnDemand, setSaveOnDemand] = useState(false);
  const [overlayShow, setOverlayShow] = useState(false);
  const [highlighter, setHighlighter] = useState([] as any);
  const [yes, setYes] = useState(false);
  const [show, setShow] = useState(false);
  const [isTourOpen, setIsTourOpen] = useState(true);
  const [time, setTime] = useState(useQuery().get("time"));
  const [isIOS, setIsIOS] = useState(false);
  const [isVideoDiv, setIsVideoDiv] = useState("");
  const utube = useRef(document.getElementById("share-hide"));
  const [timePlaceholder, setTimePlaceholder] = useState("What is a good time to call you?");
  const [timePlaceholderError, setTimePlaceholderError] = useState("Please provide a valid time.");
  const [mobileAdPath, setMobileAdPath] = useState([]);

  const closeAdModal = () => {
    setShow(false);
  };

  const handleShow = () => setShow(true);
  // const [timeCounter, setTimeCounter] = useState(0);
  // const [startCounter, setStartCounter] = useState(false);
  const opts = {
    height: "100%",
    width: "100%",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
    },
  };

  // Flag Declaration Ends

  let x: any = 0;
  let y: any = 0;

  // Effects Declaration Starts

  useEffect(() => {
    setHighlighter(
      vContext.accordionData
        .filter((i: any) => i.flag === "equipment" || i.flag === "anatomy")
        .map((m: any) => {
          return { ...m, show: false };
        })
    );
  }, [vContext.accordionData]);

  useEffect(() => {
    //console.log("&&&&&&&&&&&&&&");
   console.log(vContext.videoData.secondary_ad_path);
   setMobileAdPath(vContext.videoData.secondary_ad_path);
  }, [vContext.videoData]);
  useEffect(() => {
    setHighlighter((preData: any) =>
      preData.map((m: any) => {
        if (
          vContext.currentVideoTime >= m.time &&
          vContext.currentVideoTime <= m.time + 5
        ) {
          return { ...m, show: true };
        } else {
          return { ...m, show: false };
        }
      })
    );
  }, [vContext.currentVideoTime]);

  const docKeyPress = (e: any) => {
    //alert("fullscreen");
    if (document.fullscreenElement) {
      vContext.setFullScreenHandler(true);
    } else {
      vContext.setFullScreenHandler(false);
      if(videoData.txData[0].youtube_flag === "1")
      document.getElementsByTagName("iframe")[0].height= '360';
    }

  };

  useEffect(() => {
    // document.addEventListener("keydown", docKeyPress);
    document.addEventListener("fullscreenchange", docKeyPress);
    if(videoData.txData[0].youtube_flag != 0)
    {
      
    const setPlayingInterval = setInterval(() => {
      const currentTime = Math.round(ref.current.getYTCurrentTime());
      const YTDuration = Math.round(ref.current.getYTDuration());
     // alert(ref.current.getPlayerState());
      //setIsPlaying(false);
      setIsYTNotStarted(false);
      if(currentTime>0)
     {
      setIsPlaying(true);
        //alert(ref.current.getYTDuration()+"-"+currentTime);
      if(videoData.txData[0].transmission_status == "2")
        {
        setMax(YTDuration); // remove the setMax from HTML and use ref object to assign value
    progressBarRef.current!.max = YTDuration;
        }
        else
        {
          setMax(currentTime); // remove the setMax from HTML and use ref object to assign value
    progressBarRef.current!.max = currentTime;
        }
        /*setTimeout(() => {
          setIsPlaying(true);
          setIsYTPlaying(true);
        }, 1000);*/
     
      clearInterval(setPlayingInterval);
      }
      else if(ref.current.getPlayerState() == -1)
      {
      setIsYTNotStarted(true);
      player?.playVideo();
      //toggleYoutubePlayPause();
      }
      else if(ref.current.getPlayerState() == 0 || ref.current.getPlayerState() == 5)
      {
      setIsYTNotStarted(true);
      }
     /* else if(videoData.txData[0].transmission_status == "0")
      {
        setTimeout(() => {
          setIsPlaying(true);
          setIsYTPlaying(true);
        }, 3000);
        clearInterval(setPlayingInterval);
      }*/

      },1000);
    }
    // document.onkeyup
    ifvisible.on("statusChanged", function (e: any) {
      if (e.status === "hidden") {
        // videoData.txData[0].transmission_status === "2"
        //   ? saveTimeWatchedHandler()
        //   : saveLiveAttendeeHandler("left");
        if (videoData.txData[0].transmission_status === "2") {
          saveTimeWatchedHandler()
        }
        // if(videoData.txData[0].transmission_status === "1"){
        //   saveLiveAttendeeHandler("left");
        // }
       // if(player?.getPlayerState()== '1' && videoData.txData[0].transmission_status === "1")
       //playerRef.current!.currentTime
       if(videoData.txData[0].youtube_flag === 0 && videoData.txData[0].transmission_status === "1")
       {
        saveLiveAttendeeHandler("left");
       }
        else if (videoData.txData[0].transmission_status === "1" || player?.getCurrentTime() > 0) {
          saveLiveAttendeeHandler("left");
        }
        console.log("hidden");
        startCounter = false;
      } else if (e.status === "active") {
        console.log("active");
        if (
          videoData.txData[0].youtube_flag === 0 &&
          !playerRef.current?.paused
        ) {
          startCounter = true;
        }
      }
    });
    setInterval(() => {
      // console.log("event ...",!playerRef.current?.paused )
     // if(playerRef.current!.currentTime>5)
     // set("lastWatchTime"+vContext.transId,playerRef.current!.currentTime.toString());
      if (
        videoData.txData[0].youtube_flag === 0 &&
        !playerRef.current?.paused
      ) {
        // let count = timeCounter + 1;
        // setTimeCounter(count);
        timeCounter = timeCounter + 1;
      } else if (startCounter) {
        // console.log("event ...e", startCounter )
        timeCounter = timeCounter + 1;
      }
    }, 1000);

   setInterval(() => {
      //alert(videoData.txData[0].transmission_status);
      if(videoData.txData[0].transmission_status == "2")
      saveTimeWatchedHandler();
  }, 60000);
 
  setTimeout(() => {
    if(window.location.href.indexOf("videoDiv") > -1) {
      //alert("before");
      if(getUserAgent() == "mobile")
      vContainerRef.current!.scrollIntoView(false);
      }
  }, 2000);
 
   
  }, []);

  useEffect(() => {
    let error_flag = 0;
    if (typeof Hls === undefined) {
      alert("Please check your internet connection and refresh the page");
    }
    if (Hls.isSupported()) {
      console.log("hls js supported");
      const hls = new Hls({
        debug: true,
        autoStartLoad: false,
      });
      if(playerRef.current)
      hls.attachMedia(playerRef.current);
      hls.on(Hls.Events.MEDIA_ATTACHED, function () {
        console.log("hls js MEDIA_ATTACHED");
        hls.loadSource(videoData.txData[0].video_url);
        // hls.loadSource("https://bitdash-a.akamaihd.net/content/sintel/hls/playlist.m3u8");
        hls.on(Hls.Events.MANIFEST_PARSED, function () {
          console.log("hls js MANIFEST_PARSED");
          //alert(vContext.transId);
         // let lastWatchTime = get("lastWatchTime"+vContext.transId);
        // console.log("******************************");
         //console.log(videoData)
         let lastWatchTime = videoData.txData[0].lastVideoTime;
          //alert(lastWatchTime);
          if (time) {
            playerRef.current!.currentTime = +time;
          }
          else if(lastWatchTime)
          {
            if(videoData.txData[0].transmission_status == "2")
            playerRef.current!.currentTime = +parseInt(lastWatchTime);
          }
          playerRef.current!.muted = true;
          playerRef.current!.play();
          setIsPlaying(true);
          // if (seekRef.current!.value === "") {
          
          if (time && time!='-1') {
            console.log("time found");
            hls.startLoad(parseInt(time));
          } 
          else if (lastWatchTime && videoData.txData[0].transmission_status == "2") {
            console.log("time found");
            hls.startLoad(parseInt(lastWatchTime));
          }
          else {
            console.log("time not found");
            hls.startLoad(-1);
          }
        });
      });

      let error_status = 0;
      let errorDetailsOld = "";
      hls.on(Hls.Events.ERROR, (event: any, data: any) => {
        let errorType = data.type;
        let errorDetails = data.details;
        let errorFatal = data.fatal;
        console.log(
          "<b>error type:" +
          errorType +
          "error detail:" +
          errorDetails +
          " error fatal" +
          errorFatal +
          "</b>"
        );
        if (errorDetails != errorDetailsOld) {
        }
        switch (data.details) {
          case Hls.ErrorDetails.MANIFEST_LOAD_ERROR:
            alert("stream unavailable");
            console.log("MANIFEST_LOAD_ERROR.stream unavailable");
            break;
          case Hls.ErrorDetails.MANIFEST_LOAD_TIMEOUT:
            console.log("MANIFEST_LOAD_TIMEOUT");
            break;
          case Hls.ErrorDetails.MANIFEST_PARSING_ERROR:
            console.log("MANIFEST_PARSING_ERROR ");
            break;
          case Hls.ErrorDetails.LEVEL_EMPTY_ERROR:
            console.log("LEVEL_EMPTY_ERROR");
            break;
          case Hls.ErrorDetails.LEVEL_LOAD_ERROR:
            console.log("LEVEL_LOAD_ERROR");
            break;
          case Hls.ErrorDetails.LEVEL_LOAD_TIMEOUT:
            console.log("LEVEL_LOAD_TIMEOUT ");
            break;
          case Hls.ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
            console.log("AUDIO_TRACK_LOAD_ERROR ");
            break;
          case Hls.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
            console.log("AUDIO_TRACK_LOAD_TIMEOUT  ");
            break;
          case Hls.ErrorDetails.FRAG_LOAD_ERROR:
            console.log("FRAG_LOAD_ERROR. Slow internet. ");
            if (error_status != 1) {
              error_status = 1;
             /* toast.dark("Please check your internet.        ", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });*/
            }
            break;
          case Hls.ErrorDetails.FRAG_LOAD_TIMEOUT:
            console.log("FRAG_LOAD_TIMEOUT. No internet connection.  ");
            if (error_status != 2) {
              error_status = 2;
              /*toast.dark("Please check your internet.        ", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });*/
            }
            break;
          case Hls.ErrorDetails.KEY_LOAD_ERROR:
            console.log("KEY_LOAD_ERROR ");
            break;
          case Hls.ErrorDetails.KEY_LOAD_TIMEOUT:
            console.log("KEY_LOAD_TIMEOUT ");
            break;
          case Hls.ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR:
            console.log("MANIFEST_INCOMPATIBLE_CODECS_ERROR  ");
            break;
          case Hls.ErrorDetails.BUFFER_ADD_CODEC_ERROR:
            console.log(
              "BUFFER_ADD_CODEC_ERROR. Unsupported by browser. Please try to watch it on desktop chrome."
            );
            alert(
              "Unsupported by browser. Please try to watch it on desktop chrome."
            );
            break;
          case Hls.ErrorDetails.FRAG_DECRYPT_ERROR:
            console.log("FRAG_DECRYPT_ERROR  ");
            break;
          case Hls.ErrorDetails.FRAG_PARSING_ERROR:
            console.log("FRAG_PARSING_ERROR  ");
            break;
          case Hls.ErrorDetails.BUFFER_APPEND_ERROR:
            console.log("BUFFER_APPEND_ERROR  ");
            break;
          case Hls.ErrorDetails.BUFFER_APPENDING_ERROR:
            console.log("MANIFEST_INCOMPATIBLE_CODECS_ERROR  ");
            break;
          case Hls.ErrorDetails.BUFFER_STALLED_ERROR:
            console.log(
              "BUFFER_STALLED_ERROR. Video can stuck due to slow internet connection .    "
            );
            error_status = 4;
            /*toast.dark("Video can stuck due to slow internet connection.   ", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });*/
            break;
          case Hls.ErrorDetails.BUFFER_FULL_ERROR:
            console.log(
              "BUFFER_FULL_ERROR. Something went wrong. Please check internet connection and refresh the page   "
            );
            if (error_status != 5) {
              error_status = 5;
              /*toast.dark(
                "Something went wrong. Please check internet connection or refresh the page  ",
                {
                  position: "top-center",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                }
              );*/
            }
            break;
          case Hls.ErrorDetails.BUFFER_SEEK_OVER_HOLE:
            console.log("BUFFER_SEEK_OVER_HOLE");
            break;
          case Hls.ErrorDetails.BUFFER_NUDGE_ON_STALL:
            console.log("BUFFER_NUDGE_ON_STALL. Slow internet connection. ");
            if (error_status != 3) {
              error_status = 3;
              /*toast.dark("Slow internet connection.        ", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });*/
            }
            break;
          case Hls.ErrorDetails.REMUX_ALLOC_ERROR:
            console.log("REMUX_ALLOC_ERROR ");
            break;
          case Hls.ErrorDetails.LEVEL_SWITCH_ERROR:
            console.log("LEVEL_SWITCH_ERROR ");
            break;
          default:
            break;
        }

        if (data.fatal) {
          switch (data.type) {
            case Hls.ErrorTypes.NETWORK_ERROR:
              // try to recover network error
              console.log("fatal network error encountered, try to recover");
              hls.startLoad();
              break;
            case Hls.ErrorTypes.MEDIA_ERROR:
              if (error_flag == 0) {
                console.log("fatal media error encountered, try to recover");
                error_flag = 1;
                hls.recoverMediaError();
              } else {
                console.log(
                  "fatal media error encountered, try to recover again"
                );
                error_flag = 0;
                hls.swapAudioCodec();
                hls.recoverMediaError();
              }
              break;
            default:
              // cannot recover
              console.log("fatal error encountered, can not recover");
              hls.destroy();
              break;
          }
        }
      });
    } else if (playerRef.current) {
      if (
        playerRef.current!.canPlayType("application/vnd.apple.mpegurl")
      ) {
       /* playerRef.current!.src = videoData.txData[0].video_url;
        playerRef.current!.addEventListener("canplay", function () {
          playerRef.current!.play();
          setIsPlaying(true);
        });*/
      }
    }

    return () => {
      if (hls) {
        hls.destroy();
      }
      //setHls(null);
    };
  }, [videoData]);

  // Effects Declaration End

  // Fuction Defination Starts

  useImperativeHandle(ref, () => ({
    seekVideo(time: any) {
      var yourHeight = 54;
      // scroll to your element
      vContainerRef.current!.scrollIntoView(true);
      // now account for fixed header
      var scrolledY = window.scrollY;
      if (scrolledY) {
        window.scroll(0, scrolledY - yourHeight);
      }
      //alert(videoData.txData[0].youtube_flag);
      if(videoData.txData[0].youtube_flag==0)
      {
      playerRef.current!.currentTime = time;
      playerRef.current!.play();
      }
      else{
        //alert(time+"-"+player?.getCurrentTime());
        
        player?.seekTo(time, true);
        //alert("seekVideo");
        isYTSeek = true;
       
      }
      setIsPlaying(true);
    },
    seekLiveVideo(time: any) {
     
     //alert("inside2");
        player?.seekTo(time, true);
        
       
    },
    getYTCurrentTime() {
      return player?.getCurrentTime();
    },
    getYTDuration() {
      return player?.getDuration();
    },
    getPlayerState() {
      return player?.getPlayerState();
    },
    playYTVideo() {
      //alert("playYTVideo"+isPlaying);
      if(isYTPlaying)
      setIsPlaying(true);
      return player?.playVideo();
    },
    pauseYTVideo() {
      //alert("pauseYTVideo"+isPlaying);
      setIsPlaying(false);
      return player?.pauseVideo();
    },
    muteYTVideo() {
      setIsMute(true);
      return player?.mute();
    },
    unmuteYTVideo() {
      setIsMute(false);
      return player?.unMute();
    },
  }));

  const getUserAgent = () => {
    var isMobile = {
      Android: function () {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function () {
        return (
          navigator.userAgent.match(/IEMobile/i) ||
          navigator.userAgent.match(/WPDesktop/i)
        );
      },
      any: function () {
        return (
          isMobile.Android() ||
          isMobile.BlackBerry() ||
          isMobile.iOS() ||
          isMobile.Opera() ||
          isMobile.Windows()
        );
      },
    };

    if (isMobile.any()) {
      setIsVideoDiv("videoDiv");
      return "mobile";
    } else {
      setIsVideoDiv("");
      return "pc";
    }
  };
  //start youtube
  const onReady = (event: any) => {
    setIsYTPlaying(true);
    setPlayer(event.target);
    console.log(document.getElementsByTagName("ytp-chrome-top"), "asd");
  };

  const playLiveVideo = (e: any) => {
    setIsPlaying(true);
    if (!saveOnDemand) {
      //alert(player?.getPlayerState());
      //alert(videoData.txData[0].transmission_status);
    
      if(player?.getPlayerState()== '1' && videoData.txData[0].transmission_status === "1")
      {
      saveLiveAttendeeHandler();
      startCounter = true;
      setSaveOnDemand(true);
      }
      else
      saveOnDemandAttendeeHandler();
    }
    // setStartCounter(true)

    
  };
  //end youtube
  const saveOnDemandAttendeeHandler = () => {
    console.log("agent", getUserAgent());
    fetch(
      "https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=saveOndemandAttendee&transID=" +
      vContext.transId +
      "&userID=" +
      vContext.userId +
      "&accessPlatform=" +
      getUserAgent()
    )
      .then((res) => res.json())
      .then((saveOnDemandData) => {
        if (saveOnDemandData.status === "success") {
          setSaveOnDemand(true);
        } else {
          console.log("Fail save on demand data");
        }
      })
      .catch((error) => {
        console.log("Error:(saveOnDemandAttendee)", error);
      });
  };

  const saveLiveAttendeeHandler = (action = "joined") => {
    let counterValue = timeCounter;
    timeCounter = 0;
    fetch(
      "https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=saveLiveAttendee&transID=" +
      vContext.transId +
      "&userID=" +
      vContext.userId +
      "&action=" +
      action +
      "&accessPlatform=" +
      getUserAgent() +
      "&duration=" +
      counterValue
    )
      .then((res) => res.json())
      .then((saveLiveAttendeeData) => {
        if (saveLiveAttendeeData.status === "success") {
          console.log("save live attendee successfully!");
        } else {
          console.log("Fail save on demand data");
        }
      })
      .catch((error) => {
        console.log("Error:(saveLiveAttendeeHandler)", error);
      });
  };

  const saveTimeWatchedHandler = () => {
    //alert(playerRef.current!.currentTime);
    fetch(
      "https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=saveTimeWatched&transID=" +
      vContext.transId +
      "&userID=" +
      vContext.userId +
      "&duration=" +
      timeCounter +
      "&videoTime=" +
      playerRef.current!.currentTime
    )
      .then((res) => res.json())
      .then((saveOnDemandData) => {
        if (saveOnDemandData.status === "success") {
          console.log("saved saveOnDemand");
        } else {
          console.log("Fail save on demand data");
        }
      })
      .catch((error) => {
        console.log("Error:(saveTimeWatchedHandler)", error);
      });
  };

  // this playVideo function will execute when play event occure
  const playVideo = (e: any) => {
    // console.log("event"+ e.target.currentTime + "-->" + timeCounter);
    setIsPlaying(true);
    if (!saveOnDemand) {
      if(videoData.txData[0].transmission_status == "1")
      {
      saveLiveAttendeeHandler();
      startCounter = true;
      setSaveOnDemand(true);
      }
      else
      saveOnDemandAttendeeHandler();
    }
  
    let videoTotalDuration = Math.round(playerRef.current!.duration);
   // alert(playerRef.current!.currentTime);
    if(playerRef.current!.currentTime<videoTotalDuration)
    {
    setVideoPlayed = true;
    }
  };

  const seekVideo = (t: any) => {
    // console.log("seek video t", t);
   // alert(videoData.txData[0].youtube_flag);
    if(videoData.txData[0].youtube_flag==0)
    {
    playerRef.current!.currentTime = t;
    playerRef.current!.play();
    }
    else{
    player?.seekTo(t, true);
    }
    setIsPlaying(true);
  };

  const customPlay = () => {
    let status = ""
    // console.log("current ....", playerRef);
    if (playerRef.current!.paused || playerRef.current!.ended) {
      setIsPlaying(true);
      playerRef.current!.play();
      status = "Video Played"
    } else {
      setIsPlaying(false);
      playerRef.current!.pause();
      status = "Video Paused"
    }
    ReactGA.event({
      category: 'User Action',
      action: status,
      label: status
    });
    // setIsPlaying(!isPlaying);
  };

  const closePopupPlay = () => {
    // console.log("current ....", playerRef);
    if (isVideoPlaying) {
      playerRef.current!.play();
    } else {
      playerRef.current!.pause();
    }
    setIsPlaying(isVideoPlaying);
  };

  const updateVolumeIcon = (e: any) => {
    if (playerRef.current!.muted || playerRef.current!.volume === 0) {
    } else if (
      playerRef.current!.volume > 0 &&
      playerRef.current!.volume <= 0.3
    ) {
      setIsLow(true);
      setIsMedium(false);
      setIsHigh(false);
    } else if (
      playerRef.current!.volume > 0.3 &&
      playerRef.current!.volume <= 0.6
    ) {
      setIsLow(false);
      setIsMedium(true);
      setIsHigh(false);
    } else if (
      playerRef.current!.volume > 0.6 &&
      playerRef.current!.volume <= 1
    ) {
      setIsLow(false);
      setIsMedium(false);
      setIsHigh(true);
    }
  };
  const toggleMute = (e: any) => {
    playerRef.current!.muted = !playerRef.current!.muted;
    setIsMute(playerRef.current!.muted);
  };

  // this playVideo function will execute when ended event occure
  const videoEnded = (e: any) => {
    // console.log("event", e.target.currentTime);
    saveTimeWatchedHandler();
    setIsPlaying(!isPlaying);
    let storedlastWatchTime = videoData.txData[0].lastVideoTime;
    let videoTotalDuration = Math.round(playerRef.current!.duration);
    let nextVideoId=vContext.videoData.txData[0].nextVideoId;
    //alert(videoTotalDuration+"playing next video"+storedlastWatchTime+"playing"+setVideoPlayed);
  
   
    if((storedlastWatchTime <videoTotalDuration||setVideoPlayed) && nextVideoId!="")
    {
      alert("playing next video");
        window.location.href="?trans_id="+nextVideoId+"#videoDiv";
        //window.open("?trans_id="+nextVideoId);
    
    }
  };

  const updateVolume = () => {
    // console.log("update volumne",playerRef)
    if (playerRef.current!.muted) {
      playerRef.current!.muted = false;
      setIsMute(playerRef.current!.muted);
    }
    let vol = parseFloat(volumeRef.current!.value);
    playerRef.current!.volume = vol;
  };

  const skipAhead = (event: any) => {
    const skipTo = event.target.dataset.seek
      ? event.target.dataset.seek
      : event.target.value;
    playerRef.current!.currentTime = skipTo;
    progressBarRef.current!.value = skipTo;
    seekRef.current!.value = skipTo;
  };

  function updateSeekTooltip(event: any) {
    const skipTo = Math.round(
      (event.nativeEvent.offsetX / event.target.clientWidth) *
      parseInt(event.target.getAttribute("max"), 10)
    );
    seekRef.current!.dataset.seek = skipTo.toString();
    seekTooltipRef.current!.textContent = new Date(skipTo * 1000)
      .toISOString()
      .substr(11, 8); //`${t.minutes}:${t.seconds}`;
    const rect = playerRef.current!.getBoundingClientRect();
    seekTooltipRef.current!.style.left = `${event.pageX - rect.left}px`;
    seekTooltipRef.current!.style.top = "-20px";
    seekTooltipRef.current!.style.zIndex = "2";
  }
  const videoClick = (e: any) => {

    // console.log('hls player object', e);
    let coords = getCoords(e);
    let px = coords.pixel;
    vContext.setTagPositionHandler(coords.percentage);
    vContext.setVideoTimeHandler(playerRef.current!.currentTime);
    positionRef.current!.style.left = px.x + "px";
    positionRef.current!.style.top = px.y + "px";
    positionRef.current!.style.backgroundColor = "#000";
    // console.log("ref", positionRef);
    if (vContext.userRole !== "viewer") {
      playerRef.current!.currentTime !== 0
        ? positionRef.current!.click()
        : toast.dark("First Play Video", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      // customPlay();
      setIsVideoPlaying(!playerRef.current!.paused);
      if (!playerRef.current!.paused) {
        playerRef.current!.pause();
        setIsPlaying(!isPlaying);
      }
      // else {
      //   playerRef.current!.pause();
      // }
    } else {
      customPlay();
    }
    // }else{
    //   customPlay();

    console.log("video click")
  };
  const hide_timestamp_for_live = () => {

    const ts = document.getElementById("px-1");
    const d = document.getElementById("duration");
    { d && (d.style.display = "none") }
    { ts && (ts.style.display = "none") }

  }

  const initializeVideo = () => {
    const videoDuration = Math.round(playerRef.current!.duration);
    setMax(videoDuration); // remove the setMax from HTML and use ref object to assign value
    progressBarRef.current!.max = videoDuration;
    const time = new Date(videoDuration * 1000).toISOString().substr(11, 8);
    setDuration(time);
    {
      vContext.videoData.txData[0].transmission_status !== "2" && vContext.videoData.txData[0].youtube_flag == 0 &&
      hide_timestamp_for_live();

    }
  };

  console.log("yes11", vContext);
  const toggleFullScreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      document.getElementsByTagName("body")[0].requestFullscreen();
      // videoContainerRef.current!.requestFullscreen();
      // console.log(vContext.isVideoFullscreen);
      props.closeChats();
    }
    vContext.setFullScreenHandler(!vContext.isVideoFullscreen);
  };
  const toggleYoutubeFullScreen = () => {
    //alert(window.innerHeight +"aa"+window.innerWidth);
    
        if (vContext.isVideoFullscreen) {
          document.exitFullscreen();
          document.getElementsByTagName("iframe")[0].height= '360';
        } else {
          
    
          
          document.getElementsByTagName("body")[0].requestFullscreen();
          //alert(window.innerHeight);
          const window_height = window.innerHeight;
          
          if(window.innerWidth>window.innerHeight)
          document.getElementsByTagName("iframe")[0].height= (window_height+50)+'';
    
          props.closeChats();
        }
        vContext.setFullScreenHandler(!vContext.isVideoFullscreen);
        
      };
      const toggleYTMuteUnmute = () => {
        //alert(isMute);
        if(isMute)
        ref.current.unmuteYTVideo()
        else
        ref.current.muteYTVideo()
      };
      const toggleYoutubePlayPause = () => {
        //alert("toggleYoutubePlayPause"+player?.getPlayerState());
        if(player?.getPlayerState()==1)//isPlaying
        ref.current.pauseYTVideo()
        else
        ref.current.playYTVideo()
        

      };
      const displayYTCurrentTime = () => {
        setInterval(() => {
        
        
        const currentTime = Math.round(ref.current.getYTCurrentTime());
        
    const time = new Date(currentTime * 1000).toISOString().substr(11, 8);
   
    if(isYTPlaying)
    setYT_time(time)

    let val = Math.floor(currentTime).toString();
    seekRef.current!.value = val;
    progressBarRef.current!.value = Math.floor(currentTime);
    vContext.setCurrentVideoTimeHandler(currentTime); //updateProgress function for hls
    //alert(time);
    //seekTooltipRef.current!.textContent = time;
        },1000);

       
       
      };
      const updateYTVolume = () => {
        // console.log("update volumne",playerRef)
        //alert(volumeRef.current!.value);
        player?.setVolume(volumeRef.current!.value);
    
        if (player?.getVolume() === 0) {
        } else if (
          player?.getVolume() > 0 &&
          player?.getVolume() <= 30
        ) {
          setIsLow(true);
          setIsMedium(false);
          setIsHigh(false);
        } else if (
          player?.getVolume() > 30 &&
          player?.getVolume() <= 60
        ) {
          setIsLow(false);
          setIsMedium(true);
          setIsHigh(false);
        } else if (
          player?.getVolume() > 60 &&
          player?.getVolume() <= 100
        ) {
          setIsLow(false);
          setIsMedium(false);
          setIsHigh(true);
        }
      };
    
      const seekLiveVideo = (t: any) => {
    
        //const t1=Math.round(ref.current.getYTDuration());
        const t1=999999;
        player?.seekTo(t1, true);
        isYTSeek = false;
        //alert(t1);
        setTimeout(() => {
          const currentTime1 = Math.round(ref.current.getYTCurrentTime());
         
          //alert(currentTime1);
          setMax(currentTime1); // remove the setMax from HTML and use ref object to assign value
    progressBarRef.current!.max = currentTime1;
        }, 1000);
      }

      const skipAheadYT = (event: any) => {
        const skipTo = event.target.dataset.seek
          ? event.target.dataset.seek
          : event.target.value;
          
          player?.seekTo(skipTo, true);
          //alert("skipAheadYT");
          isYTSeek = true;
       // playerRef.current!.currentTime = skipTo;
        progressBarRef.current!.value = skipTo;
        seekRef.current!.value = skipTo;
      };
      const onPlayerStateChange = (e: any) => {
//alert(e.data);
if(e.data !=-1 && e.data !=0 && e.data !=5)
{
  //alert("playing");
setIsYTNotStarted(false);
}
else if(e.data ==0)
setIsYTNotStarted(true);
  }

 
      
     
  const updateTimeElapsed = () => {
    const currentTime = Math.round(playerRef.current!.currentTime);
    const time = new Date(currentTime * 1000).toISOString().substr(11, 8);
    setTimeElapsed(time);
  };

  const updateProgress = () => {
    let val = Math.floor(playerRef.current!.currentTime).toString();
    seekRef.current!.value = val;
    progressBarRef.current!.value = Math.floor(playerRef.current!.currentTime);
    vContext.setCurrentVideoTimeHandler(playerRef.current!.currentTime);
  };

  const animatePlayback = () => {
    playbackAnimationRef.current!.animate(
      [
        {
          opacity: 1,
          transform: "scale(1)",
        },
        {
          opacity: 0,
          transform: "scale(1.3)",
        },
      ],
      {
        duration: 500,
      }
    );
  };

  const hideControls = () => {
    if (playerRef.current!.paused) {
      return;
    }

    videoControlsRef.current!.classList.add("hide");
    setControlsVisible(false);
  };

  // showControls displays the video controls
  const showControls = () => {
    videoControlsRef.current!.classList.remove("hide");
    setControlsVisible(true);
  };

  // keyboardShortcuts executes the relevant functions for
  // each supported shortcut key
  const keyboardShortcuts = (e: any) => {
    // e.preventDefault();
    e.stopPropagation();
    const { key } = e;
    switch (key) {
      case " ":
        customPlay(); //togglePlay();
        break;
      // case "m":
      //   toggleMute(e);
      //   break;
      // case "f":
      //   toggleFullScreen();
      //   break;
      // case "p":
      //   togglePip();
      //   break;
    }
  };
  useEffect(() => {
    displayYTCurrentTime();
  }, [isYTPlaying]);
  useEffect(() => {
    // window.addEventListener('keypress', e => {
    //   console.log("keypress",e.key)
    //   keyboardShortcuts(e)
    // });
    if(navigator.userAgent.match(/iPhone|iPad|iPod/i))
    setIsIOS(true);

  }, [isIOS]);
  //Need to check with vinaya how to capture time details when redirection happen/or user navigate to other page
  //need to write logic if above scenario is valid

  function getXYpos(e: any) {
    let elm = e.target;
    x = elm.offsetLeft; // set x to elm’s offsetLeft
    y = elm.offsetTop; // set y to elm’s offsetTop

    elm = elm.offsetParent; // set elm to its offsetParent

    //use while loop to check if elm is null
    // if not then add current elm’s offsetLeft to x
    //offsetTop to y and set elm to its offsetParent
    while (elm != null) {
      x = parseInt(x) + parseInt(elm.offsetLeft);
      y = parseInt(y) + parseInt(elm.offsetTop);
      elm = elm.offsetParent;
    }

    // returns an object with "xp" (Left), "=yp" (Top) position
    return { xp: x, yp: y };
  }

  // Get X, Y coords, and displays Mouse coordinates
  function getCoords(e: any) {
    var xy_pos = getXYpos(e);
    // if IE
    if (navigator.appVersion.indexOf("MSIE") != -1) {
      // in IE scrolling page affects mouse coordinates into an element
      // This gets the page element that will be used to add scrolling value to correct mouse coords
      var standardBody =
        document.compatMode == "CSS1Compat"
          ? document.documentElement
          : document.body;

      x = e.clientX + standardBody.scrollLeft;
      y = e.clientY + standardBody.scrollTop;
    } else {
      x = e.pageX;
      y = e.pageY;
    }

    x = x - xy_pos["xp"];
    y = y - xy_pos["yp"];

    // displays x and y coords in the #coords element
    // document.getElementById('coords').innerHTML = 'X= '+ x+ ' ,Y= ' +y;
    // console.log("X= " + x + " ,Y= " + y);
    // console.log(
    //   "X= " +
    //   (x / e.target.clientWidth)  +
    //   " ,Y= " +
    //   (y / e.target.clientHeight)
    //   );
    return {
      pixel: { x: x, y: y },
      percentage: {
        x: Number((x / e.target.clientWidth).toFixed(2)),
        y: Number((y / e.target.clientHeight).toFixed(2)),
      },
    };
  }
  // Fuction Defination Ends

  // Conditional Html block defination Starts
  const popover = (
    <Popover id="popover-basic" className="video-popover">
      <VideoTag closePopup={closePopupPlay} />
    </Popover>
  );


  // Conditional Html block defination End
  const goToDetails = (e: any) => {
    // console.log('hi');
    let details = document.getElementById("video-details");
    // console.log("det",vContext.detailsRef.current!.getBoundingClientRect().top)

    window.scrollTo({
      top: vContext.detailsRef.current!.getBoundingClientRect().top - 54,
    });
    // vContext.detailsRef!.
    // if(details){
    //   console.log("det",details)
    // }
  };



  const [counter, setCounter] = useState(100);
  const intervalRef = useRef(0);

  // functions -----------------------------------

  function forwardVideo() {

    playerRef.current!.currentTime += 10;

  };

  function rewindVideo() {

    playerRef.current!.currentTime -= 10;

  };



  useEffect(() => {
    console.log("yes +++",utube, document.getElementsByTagName("iframe"));
    var elems =  document.getElementsByTagName("iframe");
    $(".ytp-chrome-top").hide();
    $("#share-hide").contents().find("#document").hide();
     console.log("+++", $("#share-hide").contents().find("body"));
    console.log(document.getElementsByTagName("ytp-chrome-top").item,"+++");

    // elems.map((item: any) => (
    //   console.log(item,"+++")
    //         ))

    if (document.getElementById("share-hide")) {
        console.log("yes +++", document.getElementsByTagName("ytp-chrome-top"));
        // document.getElementsByTagName("ytp-chrome-top").remove();
      }


    
    else {

      console.log("no +++");

    }
  }, []);

  //Actual component HTML Starts
  const renderTooltip = (
    // <Popover id="popover-title" className="tooltip-helper">
    //   {videoData.txData[0].transmission_title}  
    // </Popover>
    <Popover id="tooltip-title" className="tooltip-title">
      {/* <Popover.Content>{convertSecondToHH_MM_SS(props.data.time)}</Popover.Content> */}
      {/* <Popover.Content>{props.data.name}</Popover.Content> */}
      <Popover.Content>{videoData.txData[0].transmission_title}</Popover.Content>
    </Popover>
  );

  // const [op, setOp] = useState(false);

  // const turnopacity = () => {
  // setOp(true);

  // }

  //console.log("yes" + videoData.txData[0].transmission_ppt_id);


  return (
    <div id={isVideoDiv} className="video-container mt-3 mt-md-0 mb-3" ref={vContainerRef}>
      {!isEmpty(videoData) && (
        <>
          <div className="video-title-header justify-content-between">
            <OverlayTrigger trigger={['hover', 'focus', 'click']} placement="top" overlay={renderTooltip}>
              <div
                className="pb-1 surgery-title"
              // title={videoData.txData[0].transmission_title}
              >
                {videoData.txData[0].transmission_title}
              </div>
             
            </OverlayTrigger>
            {videoData.txData[0].conf_title &&(
              <>
               <div style={{textOverflow: "ellipsis",overflow: "hidden",whiteSpace: "nowrap",paddingBottom:"5px"
              }}>
               CME: {videoData.txData[0].conf_title}
              </div>
             
              </>
            )}
           
            <div className="d-flex align-items-center justify-content-between">
              <div className="video-legend-list">
                {videoData.txData[0].transmission_ppt_id === "0" && <div
                  className="check-surgery-details video-legend-item"
                  onClick={(e: any) => goToDetails(e)}
                >
                  Check Surgery Details
                </div>}
                <div className="video-legend-item">
                  <FaCaretDown size={26} className="legend-question" />
                  <div>Questions</div>
                </div>
                {videoData.txData[0].transmission_ppt_id == "1" ?
                  <>
                    <div className="video-legend-item">
                      <FaCaretDown size={26} className="legend-steps" />
                      <div>Topics</div>
                    </div>
                    <div className="video-legend-item">
                      <FaCaretDown size={26} className="legend-instruments" />
                      <div>Instruments Tagged</div>
                    </div>
                  </>
                  :
                  <>
                    <div className="video-legend-item">
                      <FaCaretDown size={26} className="legend-instruments" />
                      <div>Instruments Tagged</div>
                    </div>

                    <div className="video-legend-item">
                      <FaCaretDown size={26} className="legend-steps" />
                      <div>Steps</div>
                    </div>


                  </>
                }

                {videoData.txData[0].transmission_ppt_id === "1" ?
                  "" :
                  <div className="video-legend-item">
                    <FaCaretDown size={26} className="legend-anatomy" />
                    <div>Anatomy</div>
                  </div>}
              </div>
            </div>
          </div>
          <div className="blue-shadow-box">
            <div
              className="position-relative overflow-hidden"
              ref={videoContainerRef}
            >
              <div
                className={classes.playback_animation}
                id="playback_animation"
                ref={playbackAnimationRef}
              >
                <svg className={classes.playback_icons}>
                  <use className={classes.hidden} href="#play-icon"></use>
                  <use href="#pause"></use>
                </svg>
              </div>
              <OverlayTrigger
                trigger="click"
                placement="auto"
                overlay={popover}
                rootClose={true}
              >
                <div ref={positionRef} className="video-tooltip-container">
                  test
                </div>
              </OverlayTrigger>
              {videoData.txData[0].youtube_flag === 0 ? (
                !isIOS ? (
                <>
                
                  <div className="playerLogoTop">
                    <div className="annotation_box">
                      <div className="row customRow">
                        <div className="col-8">
                          <div >
                            <img className="videoLogo" src={"../" + vContext.videoData.watermark_img} alt="Logo" />
                            <span className="liveHeader fontSize11 ml-1">{videoData.txData[0].transmission_status !== "2" ? "LIVE" : "REC"}</span>
                            {/* <span className="viewCount fontSize11 ml-1">
                              <FaEye className="mr-2" size={20} />
                              {vContext.viewCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} views
                            </span> */}
                             {/*<span className="viewCount fontSize11 ml-1">{new Date(videoData.txData[0].transmission_date).toString().substring(4, 10) + "," + new Date(videoData.txData[0].transmission_date).toString().substring(10, 15)}</span>*/}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="video-player-container text-center">
                    <div className="position-relative d-inline-block1">
                      {highlighter.map((item: any) => {
                        return <VideoHighlighter item={item} />;
                      })}
                      {/* <video></video>
                  <ReactHlsPlayer */}
                   {(vContext.isVideoFullscreen && mobileAdPath.length !=0) ? (
                                 
                                  <SecondaryAdBannerFullscreen
                          data={mobileAdPath}
                        />
                              
                              )
                            :(<div></div>)}
                 
                              
                  
                      <video
                        ref={playerRef}
                        className="d-block"

                        // src="https://meditorch.pc.cdn.bitgravity.com/vod/_definst_/smil:1_1862386222.smil/playlist.m3u8"
                        // src={videoData.txData[0].video_url}
                        // autoPlay={false}
                        // controls={true}
                        width="100%"
                        height="auto"
                        onPlay={playVideo}
                        onEnded={videoEnded}
                        //playsInline
                        onClick={(e) => {
                          videoClick(e);
                          // customPlay(); // this commented may be we need to uncomment to enable play/pause video on video click event
                          // animatePlayback();
                        }}
                        onVolumeChange={updateVolumeIcon}
                        onLoadedMetadata={initializeVideo}
                        onTimeUpdate={() => {
                          updateTimeElapsed();
                          updateProgress();
                        }}
                        onMouseEnter={showControls}
                        onMouseLeave={hideControls}
                      />
                    </div>

                    <div
                      className={`video-custom-controls`}
                      id="video_controls"
                      ref={videoControlsRef}
                      onMouseEnter={showControls}
                      onMouseLeave={hideControls}
                    >
                      <div className="video_progress">
                        <div className="bottom_controls">
                          <div className="left_controls">
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              placement="top"
                              overlay={
                                <Popover
                                  id="tooltip-helper"
                                  className="tooltip-helper"
                                >
                                  <Popover.Content>
                                    {isPlaying ? "Pause" : "Play"}
                                  </Popover.Content>
                                </Popover>
                              }
                            >
                              <div
                                className="play-btn"
                                data-title={isPlaying ? "Pause" : "Play"}
                                id="play"
                                onClick={customPlay}
                              >
                                {isPlaying ? (
                                  <FaPause size={16} />
                                ) : (
                                  <FaPlay size={16} />
                                )}
                              </div>
                            </OverlayTrigger>
                          </div>
                          <div className="right_controls">
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              placement="top"
                              overlay={
                                <Popover
                                  id="tooltip-helper"
                                  className="tooltip-helper"
                                >
                                  <Popover.Content>
                                    Rewind
                                  </Popover.Content>
                                </Popover>
                              }
                            >
                              <div
                                data-title="for-back-btn"
                                className="mr-3 tooltip-btn"
                                onClick={rewindVideo}
                              // onTouchStart={rewindVideo}

                              >
                                <FaFastBackward size={16} />
                              </div>
                            </OverlayTrigger>
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              placement="top"
                              overlay={
                                <Popover
                                  id="tooltip-helper"
                                  className="tooltip-helper"
                                >
                                  <Popover.Content>
                                    Forward
                                  </Popover.Content>
                                </Popover>
                              }
                            >
                              <div
                                data-title="for-back-btn"
                                className="tooltip-btn"
                                onClick={forwardVideo}
                              >
                                <FaFastForward size={16} />
                              </div>
                            </OverlayTrigger>
                          </div>
                          <div className="progress-bar-container">
                            <div
                              className="seek_tooltip"
                              id="seek_tooltip"
                              ref={seekTooltipRef}
                            >
                              00:00
                            </div>
                            <div className="bookmarks-container">
                              {vContext.accordionData.map((m: any) => {
                                //  console.log('sanket', m);
                                return (
                                  <VideoBookmark
                                    type={
                                      m.flag == "equipment"
                                        ? "instruments"
                                        : m.flag == "chat"
                                          ? "questions"
                                          : m.flag
                                    }
                                    position={(m.time / max) * 100 + "%"}
                                    data={m}
                                    seekVideo={seekVideo}
                                  />
                                );
                              })}
                            </div>
                            <div className="progress-time">
                              <time id="time_elapsed">{timeElapsed}</time>
                              <span className="px-1" id="px-1"> / </span>
                              <time id="duration">{duration}</time>
                            </div>
                            <progress
                              id="progress_bar"
                              value="0"
                              max={max}
                              ref={progressBarRef}
                            ></progress>
                            <input
                              className={classes.seek}
                              id="seek"
                              /* value="0"*/ min="0"
                              max={max}
                              type="range"
                              step="1"
                              ref={seekRef}
                              data-seek=""
                              onInput={skipAhead}
                              onMouseMove={updateSeekTooltip}
                            />
                          </div>
                          <div className="right_controls">
                            <div className="video-volume-control mr-2">
                              {/* <OverlayTrigger trigger="click" placement="top" overlay={popoverVolume} rootClose={true}> */}

                              <div className="volume_button tooltip-btn action-btn"

                              >
                                {isMute && (
                                  <FaSlash
                                    className="mute-icon"
                                    size={20}
                                    onClick={toggleMute}
                                  />
                                )}
                                {isLow && (
                                  <ImVolumeLow size={20} onClick={toggleMute} />
                                )}
                                {isMedium && (
                                  <ImVolumeMedium
                                    size={20}
                                    onClick={toggleMute}
                                  />
                                )}
                                {isHigh && (
                                  <ImVolumeHigh
                                    size={20}
                                    onClick={toggleMute}
                                  />
                                )}

                                <div className="tooltip-container">
                                  <div className="tooltip-body">
                                    <div className="tooltip-arrow"></div>
                                    <div className="tooltip-content">
                                      <div
                                        id="volume-control"
                                        className="volume-popover"
                                      >
                                        <div className="volume-popover-container">
                                          <input
                                            className="volume"
                                            id="volume"
                               /* value="1" */ data-mute="0.5"
                                            type="range"
                                            max="1"
                                            min="0"
                                            step="0.01"
                                            onInput={updateVolume}
                                            ref={volumeRef}
                                          />
                                          {/* <div data-title={isMute ? "Unmute" : "Mute"} className="volume_button tooltip-btn" onClick={toggleMute} >
                           {isMute && <FaSlash className="mute-icon" size={20} />}
                           {isLow && <ImVolumeLow size={20} />}
                           {isMedium && <ImVolumeMedium size={20} />}
                           {isHigh && <ImVolumeHigh size={20} />}
                         </div> */}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* </OverlayTrigger> */}
                            </div>
                            {/* <div className="video-volume-control mr-2">
                        <OverlayTrigger trigger="click" placement="top" overlay={popoverVolume} rootClose={true}>
                          <div className="volume_button tooltip-btn action-btn">
                            {isMute && <FaSlash className="mute-icon" size={20} />}
                            {isLow && <ImVolumeLow size={20} />}
                            {isMedium && <ImVolumeMedium size={20} />}
                            {isHigh && <ImVolumeHigh size={20} />}
                            <div className="tooltip-container">
                              <div className="tooltip-body">
                                <div className="tooltip-arrow"></div>
                                <div className="tooltip-content">Volume</div>
                              </div>
                            </div>
                          </div>
                        </OverlayTrigger>
                      </div>      */}
                            {/* <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={
                        <Popover id="tooltip-helper" className="tooltip-helper">
                          <Popover.Content>PIP (p)</Popover.Content>
                        </Popover>}>
                        <div data-title="PIP (p)" className="pip_button action-btn mr-2">
                          <BsPip size={25} color="#fff" />
                        </div>
                      </OverlayTrigger>      */}
                            {/* <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={
                        <Popover id="tooltip-helper" className="tooltip-helper">
                          <Popover.Content>Full screen (f)</Popover.Content>
                        </Popover>}> */}
                            <div
                              data-title="Full screen (f)"
                              className="fullscreen_button action-btn tooltip-btn"
                              onClick={toggleFullScreen}
                            >
                              {vContext.isVideoFullscreen ? (
                                <MdFullscreenExit size={25} color="#fff" />
                              ) : (
                                <MdFullscreen size={25} color="#fff" />
                              )}
                              <div
                                className="tooltip-container"
                                style={{
                                  transform: "translateX(-25px)",
                                  minWidth: "130px",
                                }}
                              >
                                <div className="tooltip-body">
                                  <div
                                    className="tooltip-arrow"
                                    style={{ transform: "translateX(25px)" }}
                                  ></div>
                                  <div className="tooltip-content">
                                    Full screen (f)
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* </OverlayTrigger>             */}
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                </>
                ):
                (
                  <>
                  <div className="playerLogoTop"  style={{
                                 
                                 left: "20%",
                               }}>
                    <div className="annotation_box">
                      <div className="row customRow">
                        <div className="col-8">
                          <div>
                            <img className="videoLogo" src={"../" + vContext.videoData.watermark_img} alt="Logo" />
                            <span className="liveHeader fontSize11 ml-1">{videoData.txData[0].transmission_status !== "2" ? "LIVE" : "REC"}</span>
                            {/* <span className="viewCount fontSize11 ml-1">
                              <FaEye className="mr-2" size={20} />
                              {vContext.viewCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} views
                            </span> */}
                            {/*<span className="viewCount fontSize11 ml-1">{new Date(videoData.txData[0].transmission_date).toString().substring(4, 10) + "," + new Date(videoData.txData[0].transmission_date).toString().substring(10, 15)}</span>*/}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="video-player-container text-center">
                    <div className="position-relative d-inline-block1">
                      {highlighter.map((item: any) => {
                        return <VideoHighlighter item={item} />;
                      })}
                      {/* <video></video>
                  <ReactHlsPlayer */}
                    <video
                        ref={playerRef}
                        className="d-block"

                        // src="https://meditorch.pc.cdn.bitgravity.com/vod/_definst_/smil:1_1862386222.smil/playlist.m3u8"
                       src={videoData.txData[0].video_url}
                        //autoPlay={true}
                        muted={true}
                        controls={true}
                        width="100%"
                        height="auto"
                        onPlay={playVideo}
                        onEnded={videoEnded}
                        //playsInline
                        onLoadedMetadata={initializeVideo}
                       
                      />
                    </div>

                
                    <div style={{
                                  display: "none",
                                }} 
                      className={`video-custom-controls`}
                      id="video_controls"
                      ref={videoControlsRef}
                      onMouseEnter={showControls}
                      onMouseLeave={hideControls}
                    >
                      <div className="video_progress">
                        <div className="bottom_controls">
                          <div className="left_controls">
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              placement="top"
                              overlay={
                                <Popover
                                  id="tooltip-helper"
                                  className="tooltip-helper"
                                >
                                  <Popover.Content>
                                    {isPlaying ? "Pause" : "Play"}
                                  </Popover.Content>
                                </Popover>
                              }
                            >
                              <div
                                className="play-btn"
                                data-title={isPlaying ? "Pause" : "Play"}
                                id="play"
                                onClick={customPlay}
                              >
                                {isPlaying ? (
                                  <FaPause size={16} />
                                ) : (
                                  <FaPlay size={16} />
                                )}
                              </div>
                            </OverlayTrigger>
                          </div>
                          <div className="right_controls">
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              placement="top"
                              overlay={
                                <Popover
                                  id="tooltip-helper"
                                  className="tooltip-helper"
                                >
                                  <Popover.Content>
                                    Rewind
                                  </Popover.Content>
                                </Popover>
                              }
                            >
                              <div
                                data-title="for-back-btn"
                                className="mr-3 tooltip-btn"
                                onClick={rewindVideo}
                              // onTouchStart={rewindVideo}

                              >
                                <FaFastBackward size={16} />
                              </div>
                            </OverlayTrigger>
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              placement="top"
                              overlay={
                                <Popover
                                  id="tooltip-helper"
                                  className="tooltip-helper"
                                >
                                  <Popover.Content>
                                    Forward
                                  </Popover.Content>
                                </Popover>
                              }
                            >
                              <div
                                data-title="for-back-btn"
                                className="tooltip-btn"
                                onClick={forwardVideo}
                              >
                                <FaFastForward size={16} />
                              </div>
                            </OverlayTrigger>
                          </div>
                          <div className="progress-bar-container">
                            <div
                              className="seek_tooltip"
                              id="seek_tooltip"
                              ref={seekTooltipRef}
                            >
                              00:00
                            </div>
                            <div className="bookmarks-container">
                              {vContext.accordionData.map((m: any) => {
                                //  console.log('sanket', m);
                                return (
                                  <VideoBookmark
                                    type={
                                      m.flag == "equipment"
                                        ? "instruments"
                                        : m.flag == "chat"
                                          ? "questions"
                                          : m.flag
                                    }
                                    position={(m.time / max) * 100 + "%"}
                                    data={m}
                                    seekVideo={seekVideo}
                                  />
                                );
                              })}
                            </div>
                            <div className="progress-time">
                              <time id="time_elapsed">{timeElapsed}</time>
                              <span className="px-1" id="px-1"> / </span>
                              <time id="duration">{duration}</time>
                            </div>
                            <progress
                              id="progress_bar"
                              value="0"
                              max={max}
                              ref={progressBarRef}
                            ></progress>
                            <input
                              className={classes.seek}
                              id="seek"
                              /* value="0"*/ min="0"
                              max={max}
                              type="range"
                              step="1"
                              ref={seekRef}
                              data-seek=""
                              onInput={skipAhead}
                              onMouseMove={updateSeekTooltip}
                            />
                          </div>
                          <div className="right_controls">
                            <div className="video-volume-control mr-2">
                              {/* <OverlayTrigger trigger="click" placement="top" overlay={popoverVolume} rootClose={true}> */}

                              <div className="volume_button tooltip-btn action-btn"

                              >
                                {isMute && (
                                  <FaSlash
                                    className="mute-icon"
                                    size={20}
                                    onClick={toggleMute}
                                  />
                                )}
                                {isLow && (
                                  <ImVolumeLow size={20} onClick={toggleMute} />
                                )}
                                {isMedium && (
                                  <ImVolumeMedium
                                    size={20}
                                    onClick={toggleMute}
                                  />
                                )}
                                {isHigh && (
                                  <ImVolumeHigh
                                    size={20}
                                    onClick={toggleMute}
                                  />
                                )}

                                <div className="tooltip-container">
                                  <div className="tooltip-body">
                                    <div className="tooltip-arrow"></div>
                                    <div className="tooltip-content">
                                      <div
                                        id="volume-control"
                                        className="volume-popover"
                                      >
                                        <div className="volume-popover-container">
                                          <input
                                            className="volume"
                                            id="volume"
                               /* value="1" */ data-mute="0.5"
                                            type="range"
                                            max="1"
                                            min="0"
                                            step="0.01"
                                            onInput={updateVolume}
                                            ref={volumeRef}
                                          />
                                          {/* <div data-title={isMute ? "Unmute" : "Mute"} className="volume_button tooltip-btn" onClick={toggleMute} >
                           {isMute && <FaSlash className="mute-icon" size={20} />}
                           {isLow && <ImVolumeLow size={20} />}
                           {isMedium && <ImVolumeMedium size={20} />}
                           {isHigh && <ImVolumeHigh size={20} />}
                         </div> */}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* </OverlayTrigger> */}
                            </div>
                            {/* <div className="video-volume-control mr-2">
                        <OverlayTrigger trigger="click" placement="top" overlay={popoverVolume} rootClose={true}>
                          <div className="volume_button tooltip-btn action-btn">
                            {isMute && <FaSlash className="mute-icon" size={20} />}
                            {isLow && <ImVolumeLow size={20} />}
                            {isMedium && <ImVolumeMedium size={20} />}
                            {isHigh && <ImVolumeHigh size={20} />}
                            <div className="tooltip-container">
                              <div className="tooltip-body">
                                <div className="tooltip-arrow"></div>
                                <div className="tooltip-content">Volume</div>
                              </div>
                            </div>
                          </div>
                        </OverlayTrigger>
                      </div>      */}
                            {/* <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={
                        <Popover id="tooltip-helper" className="tooltip-helper">
                          <Popover.Content>PIP (p)</Popover.Content>
                        </Popover>}>
                        <div data-title="PIP (p)" className="pip_button action-btn mr-2">
                          <BsPip size={25} color="#fff" />
                        </div>
                      </OverlayTrigger>      */}
                            {/* <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={
                        <Popover id="tooltip-helper" className="tooltip-helper">
                          <Popover.Content>Full screen (f)</Popover.Content>
                        </Popover>}> */}
                            <div
                              data-title="Full screen (f)"
                              className="fullscreen_button action-btn tooltip-btn"
                              onClick={toggleFullScreen}
                            >
                              {vContext.isVideoFullscreen ? (
                                <MdFullscreenExit size={25} color="#fff" />
                              ) : (
                                <MdFullscreen size={25} color="#fff" />
                              )}
                              <div
                                className="tooltip-container"
                                style={{
                                  transform: "translateX(-25px)",
                                  minWidth: "130px",
                                }}
                              >
                                <div className="tooltip-body">
                                  <div
                                    className="tooltip-arrow"
                                    style={{ transform: "translateX(25px)" }}
                                  ></div>
                                  <div className="tooltip-content">
                                    Full screen (f)
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* </OverlayTrigger>             */}
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>


                </>
                )
              ) : (
                isIOS ? (
                <>
                 <div className="playerLogoTop">
                    <div className="annotation_box">
                      <div className="row customRow">
                        <div className="col-8">
                          <div >
                            <img className="videoLogo" src={"../" + vContext.videoData.watermark_img} alt="Logo" />
                            {videoData.txData[0].transmission_status !== "2" && <><span className="liveHeader fontSize11 ml-1">LIVE</span>
                              {/* <span className="viewCount fontSize11 ml-1">00:26</span> */}
                            </>
                            }
                            {/* <span className="viewCount fontSize11 ml-1">
                              <FaEye className="mr-2" size={20} />
                              {vContext.viewCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} views
                            </span> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <YouTube
                    videoId={videoData.txData[0].youtube_video_id}
                    opts={{ width: "100%", playerVars: { autoplay: 1 } }}
                    onReady={onReady}

                    id={"share-hide"}
                    onPlay={playLiveVideo}
                    onPause={() => {
                      startCounter = false;
                    }}
                    onEnd={() => {
                      startCounter = false;
                    }}
                  />
                </>
                  ):
                  (
                <>
                 <div className="playerLogoTop">
                    <div className="annotation_box">
                      <div className="row customRow">
                        <div className="col-8">
                          <div >
                            <img className="videoLogo" src={"../" + vContext.videoData.watermark_img} alt="Logo" />
                            <span className="liveHeader fontSize11 ml-1">{videoData.txData[0].transmission_status !== "2" ? "LIVE" : "REC"}</span>
                            
                            {/* <span className="viewCount fontSize11 ml-1">
                              <FaEye className="mr-2" size={20} />
                              {vContext.viewCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} views
                            </span> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  { (isPlaying || isYTNotStarted) ? (
                    <>
                  <div id="video_overlap" style={{
                                  position: "absolute",
                                  top: "0px",
                                  left: "0px",
                                  width:"100%",
                                  height:"100%",
                                }} onClick={toggleYoutubePlayPause} >
                                 
                                  </div>
                                  </>
                 ):(
                  <>
                             <div id="video_overlap" style={{
                                  position: "absolute",
                                  top: "0px",
                                  left: "0px",
                                  width:"100%",
                                  height:"100%",
                                }} onClick={toggleYoutubePlayPause} >
                                 
                                  </div>     
                                </>
                                
                 )}
                 {(vContext.isVideoFullscreen && mobileAdPath.length !=0) ? (
                                 
                                 <SecondaryAdBannerFullscreen
                         data={mobileAdPath}
                       />
                             
                             )
                           :(<div></div>)}
                 
                  <YouTube
                    videoId={videoData.txData[0].youtube_video_id}
                    opts={{ width: "100%", playerVars: { autoplay: 1,controls:0,mute:1,rel:0 } }}
                    onReady={onReady}

                    id={"share-hide"}
                    onPlay={playLiveVideo}
                    onStateChange={onPlayerStateChange} 
                    onPause={() => {
                      startCounter = false;
                      //setIsPlaying(false);
                    }}
                    onEnd={() => {
                      startCounter = false;
                      setIsPlaying(false);
                    }}
                  />
<div
                      className={`video-YT-custom-controls`}
                      id="video_controls"
                      ref={videoControlsRef}
                     
                    >
                      <div className="video_progress">
                        <div className="bottom_controls">
                          <div className="left_controls">
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              placement="top"
                              overlay={
                                <Popover
                                  id="tooltip-helper"
                                  className="tooltip-helper"
                                >
                                  <Popover.Content>
                                    {isPlaying ? "Pause" : "Play"}
                                  </Popover.Content>
                                </Popover>
                              }
                            >
                              <div
                                className="play-btn"
                                data-title={isPlaying ? "Pause" : "Play"}
                                id="play"
                                onClick={toggleYoutubePlayPause}
                              >
                                {isPlaying ? (
                                  <FaPause size={16} />
                                ) : (
                                  <FaPlay size={16} />
                                )}
                              </div>
                            </OverlayTrigger>
                          </div>
                          <div className="right_controls">
                           
                             
                            
                              
                          </div>
                          <div className="progress-bar-container">
                            <div
                              className="seek_tooltip"
                              id="seek_tooltip"
                              ref={seekTooltipRef}
                            >
                              00:00
                            </div>
                            <div className="bookmarks-container">
                              {vContext.accordionData.map((m: any) => {
                                //  console.log('sanket', m);
                                return (
                                  <VideoBookmark
                                    type={
                                      m.flag == "equipment"
                                        ? "instruments"
                                        : m.flag == "chat"
                                          ? "questions"
                                          : m.flag
                                    }
                                    position={(m.time / max) * 100 + "%"}
                                    data={m}
                                    seekVideo={seekVideo}
                                  />
                                );
                              })}
                            </div>
                            <div className="progress-time">
                              <time id="time_elapsed">{YT_time}</time>
                              
                            </div>
                           
                            <progress
                              id="progress_bar"
                              value={max}
                              max={max}
                              ref={progressBarRef}
                            ></progress>
                            <input
                              className={classes.seek}
                              id="seek"
                              /* value="0"*/ min="0"
                              max={max}
                              type="range"
                              step="1"
                              ref={seekRef}
                              data-seek=""
                              onInput={skipAheadYT}
                              onMouseMove={updateSeekTooltip}
                            />
                          </div>
                         
                          <div className="right_controls">
                          {videoData.txData[0].transmission_status !== "2" && 
                          <>
                          <div className="video-volume-control mr-2">
                          
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              placement="top"
                              overlay={
                                <Popover
                                  id="tooltip-helper"
                                  className="tooltip-helper"
                                >
                                  <Popover.Content>
                                  Go to Live position
                                  </Popover.Content>
                                </Popover>
                              }
                            >
                              <div data-title="Go to Live position" style={{backgroundColor: liveIconColor}} className="progress-live-icon action-btn liveHeader" onClick={seekLiveVideo}>
                              LIVE
                              
                            </div>
                            </OverlayTrigger>

                            </div>
                          
                            
                            </>
                            }
                            <div className="video-volume-control mr-2">
                              {/* <OverlayTrigger trigger="click" placement="top" overlay={popoverVolume} rootClose={true}> */}

                              <div className="volume_button tooltip-btn action-btn"

                              >
                                {isMute && (
                                  <FaSlash
                                    className="mute-icon"
                                    size={20}
                                    onClick={toggleYTMuteUnmute}
                                  />
                                )}
                                {isLow && (
                                  <ImVolumeLow size={20} onClick={toggleYTMuteUnmute} />
                                )}
                                {isMedium && (
                                  <ImVolumeMedium
                                    size={20}
                                    onClick={toggleYTMuteUnmute}
                                  />
                                )}
                                {isHigh && (
                                  <ImVolumeHigh
                                    size={20}
                                    onClick={toggleYTMuteUnmute}
                                  />
                                )}

                                
<div className="tooltip-container" >
                                  <div className="tooltip-body">
                                    <div className="tooltip-arrow"></div>
                                    <div className="tooltip-content">
                                      <div
                                        id="volume-control"
                                        className="volume-popover"
                                      >
                                        <div className="volume-popover-container">
                                          <input
                                            className="volume"
                                            id="volume"
                               /* value="1" */ data-mute="0.5"
                                            type="range"
                                            max="100"
                                            min="0"
                                            step="1"
                                            onInput={updateYTVolume}
                                            ref={volumeRef}
                                          />
                                          {/* <div data-title={isMute ? "Unmute" : "Mute"} className="volume_button tooltip-btn" onClick={toggleMute} >
                           {isMute && <FaSlash className="mute-icon" size={20} />}
                           {isLow && <ImVolumeLow size={20} />}
                           {isMedium && <ImVolumeMedium size={20} />}
                           {isHigh && <ImVolumeHigh size={20} />}
                         </div> */}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>


                              </div>


                              {/* </OverlayTrigger> */}
                            </div>
                            
                            <div
                              data-title="Full screen (f)"
                              className="fullscreen_button action-btn tooltip-btn"
                              onClick={toggleYoutubeFullScreen}
                            >
                              {vContext.isVideoFullscreen ? (
                                <MdFullscreenExit size={25} color="#fff" />
                              ) : (
                                <MdFullscreen size={25} color="#fff" />
                              )}
                              <div
                                className="tooltip-container"
                                style={{
                                  transform: "translateX(-25px)",
                                  minWidth: "130px",
                                }}
                              >
                                <div className="tooltip-body">
                                  <div
                                    className="tooltip-arrow"
                                    style={{ transform: "translateX(25px)" }}
                                  ></div>
                                  <div className="tooltip-content">
                                    Full screen (f)
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* </OverlayTrigger>             */}
                          </div>
                        </div>
                      </div>
                    </div>


                </>
              )
      )//end of youtube android
              }
            </div>




            <VideoDescription videoData={videoData} />

          </div>
      
      <div>
          <Modal show={show} onHide={closeAdModal}>
           <AdPopup timePlaceholder={timePlaceholder} timePlaceholderError={timePlaceholderError} oncloseEvent={closeAdModal} />
            </Modal>
          </div>

        </>
      )}
    </div>
    
    
  );
  //Actual component HTML Starts
});

export default VideoPlayer;
